<template>
    <v-dialog v-if="isView" v-model="isView" persistent>
        <v-card class="mt-3 pa-1">
            <Title title="圃場管理">
                <v-spacer />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-row align="center" justify="center" no-gutters>
                        <v-col cols="12">
                            <v-img src="@/assets/logo.png" max-height="80" contain />
                            <div style="width:100%; text-align:center" class="title">Ver.{{systemVersion}}</div>
                            <div style="width:100%; text-align:center" class="body-1">
                                Copyright. Tomson
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
                <!-- <table style="width:100%">
                    <tr>
                        <td style="text-align:center" class="title font-weight-bold">
                            <v-img src="@/assets/logo.png" max-width="400" />
                        </td>
                    </tr>
                    <tr>
                        <td>Ver.{{systemVersion}}</td>
                    </tr>
                </table>
                <v-container>
                    <v-row dense>
                        <v-col>
                            圃場管理 Ver{{systemVersion}}
                        </v-col>
                    </v-row>
                </v-container> -->
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn class="primary" @click="onClickFeedback">
                    <v-icon>mdi-message-alert</v-icon>
                    フィードバックを送る
                </v-btn>
            </v-card-actions>
        </v-card>
        <NotificationCreator ref="notificationCreator" />
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import NotificationCreator from '@/components/notification/items/NotificationCreator';
    import Confirm from '@/components/tools/ConfirmDialog';
    
    export default {
        components: {
            Title,
            TitleButton,
            NotificationCreator,
            Confirm
        },
        data: function () {
            return {
                isView: false
            }
        },
        computed: {
            systemVersion: function () {
                return this.$store.getters["systemVersion"]
            },
        },
        methods: {
            onClickFeedback: function () {
                this.$refs.notificationCreator.show(
                    {
                        type: "user",
                    }
                )
            },
            /**
             * このダイアログを表示
             */
            show: function () {
                console.log("show")
                this.isView = true
            }
        }
    }
</script>
